import * as React from "react";
const SvgFiRrSwipeLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-swipe-left_svg__a)">
      <path
        fill="#062147"
        d="M17.98 10.376 12 9.18V3.107C12 1.591 10.924.272 9.497.04a3 3 0 0 0-2.439.674A3 3 0 0 0 6 3v11.566l-.955-.759A3 3 0 0 0 .94 18.181l3.71 3.577A7.97 7.97 0 0 0 10.203 24h6.798c2.757 0 5-2.243 5-5v-3.72a5.01 5.01 0 0 0-4.02-4.904zM20 19c0 1.654-1.346 3-3 3h-6.798a5.97 5.97 0 0 1-4.165-1.68l-3.72-3.588a1.004 1.004 0 0 1-.047-1.416 1 1 0 0 1 .694-.315H3c.253 0 .496.097.74.32l2.637 2.1A.998.998 0 0 0 8 16.64V3a1.002 1.002 0 0 1 1.175-.986c.463.075.825.555.825 1.093V10a1 1 0 0 0 .804.98l6.784 1.356A3.01 3.01 0 0 1 20 15.278zm4-15a1 1 0 0 1-1 1h-6.128l1.292 1.293a.999.999 0 1 1-1.414 1.414l-2.073-2.074A2.3 2.3 0 0 1 14 4c0-.617.24-1.197.678-1.634L16.75.293a.999.999 0 1 1 1.414 1.414L16.872 3H23a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-swipe-left_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSwipeLeft;
